import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";
import { Plus } from "lucide-react";

export default function Autorisations() {
  const { labels, zoneName } = useApp();
  const [rows, setRows] = useState([]);
  const nav = useNavigate();

  useEffect(() => { api.get("/autorisations").then((r) => setRows(r.data.slice().reverse())); }, []);

  const columns = [
    { key: "id", label: "Réf.", mono: true, width: 100 },
    { key: "date", label: "Date", mono: true, width: 110 },
    { key: "entNom", label: "Entreprise" },
    { key: "zone", label: "Zone", render: (r) => zoneName(r.zone) },
    { key: "travaux", label: "Travaux", sortable: false, render: (r) => <span style={{ fontSize: ".78rem" }}>{r.typesTravail.map((t) => labels.travaux[t]).join(", ")}</span> },
    { key: "statut", label: "Statut", width: 120,
      filter: Object.entries(labels.statutsAt).map(([value, label]) => ({ value, label })),
      render: (r) => <StatusBadge value={r.statut} label={labels.statutsAt[r.statut]} /> },
  ];

  return (
    <div>
      <div className="page-head">
        <div><div className="crumb">Registre</div><h1>Autorisations de travail</h1></div>
        <button className="btn btn-p" onClick={() => nav("/autorisations/new")} data-testid="new-auto-btn"><Plus size={15} />Nouvelle autorisation</button>
      </div>
      <DataTable testid="autos-table" columns={columns} data={rows}
        searchKeys={["id", "entNom", "desc"]} onRowClick={(r) => nav(`/autorisations/${r.id}`)} />
    </div>
  );
}
